import {
  Thermometer,
  Ruler,
  Link as LinkIcon,
  Zap,
  Gauge,
  ArrowLeftRight,
  Battery,
  Activity,
  RefreshCw,
  TrendingDown,
  TrendingUp,
  Power,
  Minus,
} from 'lucide-react';

export const calculatorTools = [
  { id: 'cable-limiting-temperature', title: 'Cable Limiting Temperature Calc', description: 'Calculate cable temperature limits', icon: Thermometer },
  { id: 'cable-size', title: 'Cable Size Calc', description: 'Calculate required cable size', icon: Ruler },
  { id: 'earthing-bonding', title: 'Earthing & Bonding', description: 'Earthing and bonding calculations', icon: LinkIcon },
  { id: 'kva-calc', title: 'kVA Calc', description: 'Calculate kVA ratings', icon: Zap },
  { id: 'max-zs-values', title: 'Max Zs Values', description: 'Calculate maximum Zs values', icon: Gauge },
  { id: 'ohms-law', title: 'Ohms Law Calc', description: 'Calculate voltage, current, resistance', icon: ArrowLeftRight },
  { id: 'pfc-calc', title: 'PFC Calc', description: 'Prospective fault current calculator', icon: Battery },
  { id: 'rfc-line-cpc-ratio', title: 'RFC Line to CPC Ratio Calc', description: 'Ring final circuit line to CPC ratio', icon: Activity },
  { id: 'rfc-r1-r2-converter', title: 'RFC r1 r2 to R1 + R2 Convertor', description: 'Convert r1 r2 measurements to R1 + R2', icon: RefreshCw },
  { id: 'voltage-drop-ac', title: 'Voltage Drop Calculator AC', description: 'Calculate AC voltage drop', icon: TrendingDown },
  { id: 'voltage-drop-dc', title: 'Voltage Drop Calculator DC', description: 'Calculate DC voltage drop', icon: TrendingUp },
  { id: 'watt-amps-volts', title: 'Watt Amps Volts Calculator', description: 'Calculate power, current, or voltage', icon: Power },
  { id: 'zs-ze-r1-r2', title: 'Zs - Ze = (R1+R2) Calculator', description: 'Calculate (R1+R2) from Zs and Ze', icon: Minus },
];
